import React from "react";
import Styles from "./Spinner.module.css";

const Spinner = () => {
  return <div className={Styles.Loader}>Loading...</div>;
};

export default Spinner;
